import React, { useState, useEffect } from 'react';
import { fetchCancelPolicies, calcCancelFee, hasUnpaidCancelFee } from "utils/cancelPolicy";
import {
    Container, Row, Col, Spinner, Button, Badge,
    Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input, Alert
} from 'reactstrap';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import Overview from './Overview';
import DetailsSection from './DetailsSection';
import { liveFirestore } from "../../../helpers/firebase_live";

const JobDetails = () => {
    document.title = "Taşıma Detayları | LojGo";
    
    const { id } = useParams(); 
    const navigate = useNavigate();

    const [tripDetail, setTripDetail] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [hasLiveLocation, setHasLiveLocation] = useState(false);
    
    // 1. Kullanıcı ve Rol Bilgileri
const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
const userId = authUser?.ID;
const userType = Number(authUser?.Users_Type_ID);
const isDriver = userType === 2 || userType === 4; // Sürücü / Çekici
const isCustomer = userType === 1;
const isAdmin = userType === 3; // ÖNEMLİ: Kendi veritabanınızdaki Admin rol ID'sini (Örn: 3, 99 vs.) buraya yazın.

// Admin'i de teklif verebilen roller arasına ekliyoruz:
// canBid tanımını değiştirin (isCustomer sildik)
const canBid = (isDriver || isAdmin) && !isCustomer;


    // 2. Ceza / Borç Kontrol State'leri
    const [hasDebt, setHasDebt] = useState(false);
    const [debtAmount, setDebtAmount] = useState(0);

    // Çekici Sertifikası (Users_Document.TowingCertificate) — sürücünün çekici işine teklif verebilmesi için gereklidir
    const [hasTowingCert, setHasTowingCert] = useState(false);

    useEffect(() => {
        const fetchTowingCert = async () => {
            if (!userId || !isDriver) return;
            try {
                const res = await fetch(`https://hiflowapi.stechomeyazilim.info/Users_Document?$filter=Users_ID eq ${userId}`);
                if (!res.ok) return;
                const data = await res.json();
                const doc = (data?.value && data.value[0]) || null;
                const cert = doc?.TowingCertificate;
                setHasTowingCert(!!(cert && String(cert).trim().length > 0));
            } catch (e) {
                console.error("Çekici sertifikası kontrol edilemedi:", e);
            }
        };
        fetchTowingCert();
    }, [userId, isDriver]);

    // Sürücü çekici işine sertifika olmadan teklif veremez (admin'in kısıtlaması yok)
    const isTowJob = tripDetail?.advertTypeId === 2;
    const towCertBlocked = isDriver && isTowJob && !hasTowingCert;

    // 3. İptal Onay Modalı
    const [cancelModal, setCancelModal] = useState({ open: false, fee: 0, feeMsg: "", pricingId: null, diffDays: 0 });
    const [cancelling, setCancelling] = useState(false);

    // 4. Teklif Kontrol State'leri
    const [userOffer, setUserOffer] = useState(null);

    // 5. HIZLI TEKLİF (QUICK BID) STATE'LERİ
    const [quickBidModal, setQuickBidModal] = useState(false);
    const [quickBidLoading, setQuickBidLoading] = useState(false);
    const [quickBidDate, setQuickBidDate] = useState("");        // Delivery_Date (başlangıç tarihi)
    const [quickBidEndDate, setQuickBidEndDate] = useState("");  // DateTime_ (bitiş tarihi)
    const [quickBidStartTime, setQuickBidStartTime] = useState("");
    const [quickBidEndTime, setQuickBidEndTime] = useState("");

    // 6. HIZLI TEKLİF FİYATI YÖNETİMİ (Admin manuel override)
    const [quickOfferEditModal, setQuickOfferEditModal]   = useState(false);
    const [quickOfferEditValue, setQuickOfferEditValue]   = useState("");
    const [quickOfferSaveLoading, setQuickOfferSaveLoading] = useState(false);

    const toggleQuickBidModal = () => setQuickBidModal(!quickBidModal);

  useEffect(() => {
    if (!id) return;
    const checkLiveLocation = async () => {
      try {
        const doc = await liveFirestore.collection("live_locations").doc(`mission_${id}`).get();
        setHasLiveLocation(doc.exists);
      } catch {
        setHasLiveLocation(false);
      }
    };
    checkLiveLocation();
  }, [id]);

  useEffect(() => {
        const fetchAdvertDetails = async () => {
            setIsLoading(true);
            try {
                const expandQuery = "Users_Car,Advert_Location,Invoince,Advert_Type,Advert_Offers($expand=Users),Advert_DeliveryStatus,Advert_Document,Advert_Task_Report,Advert_Rating";
                
                // 1. AŞAMA: Sadece Advert'i (ve ilişkili tabloları) çekiyoruz. 
                // (Advert_Expenses tablosunda Advert_ID olmadığı için onu Promise.all içinden çıkardık)
                const response = await fetch(`https://hiflowapi.stechomeyazilim.info/Advert?$filter=ID eq ${id}&$expand=${expandQuery}`);

                if (!response.ok) {
                    throw new Error("Veri çekilemedi");
                }

                const result = await response.json();
                const advertData = result.value ? result.value[0] : (Array.isArray(result) ? result[0] : result);

                if (advertData) {
                    const car = advertData.Users_Car || {};
                    const location = Array.isArray(advertData.Advert_Location) ? advertData.Advert_Location[0] : (advertData.Advert_Location || {});
                    const invoice = advertData.Invoince || null;
                    const advertType = advertData.Advert_Type || {};
                    let offers = advertData.Advert_Offers || [];

                    if (isCustomer) {
        offers = []; 
    }
    
                    // Eğer kullanıcı müşteri ise sadece kendi tekliflerini görsün
                    if (isCustomer) {
                        offers = offers.filter(offer => offer.Users_ID === userId);
                    }

                    // Mevcut Teklif Kontrolü
                    const existingOffer = userId ? offers.find(offer => offer.Users_ID === userId) : null;
                    setUserOffer(existingOffer || null);

                    // 2. AŞAMA: MASRAFLARI ÇEKME (ADVERT_OFFERS_ID KULLANARAK)
                    let currentOfferExpenses = [];
                    if (existingOffer) {
                        try {
                            const expensesResponse = await fetch(`https://hiflowapi.stechomeyazilim.info/Advert_Expenses?$filter=Advert_Offers_ID eq ${existingOffer.ID}&$orderby=ID desc`);
                            if (expensesResponse.ok) {
                                const expensesResult = await expensesResponse.json();
                                currentOfferExpenses = expensesResult.value || [];
                            }
                        } catch (expError) {
                            console.error("Masraflar çekilirken hata:", expError);
                        }
                    }

                    // STATE HARİTALAMASI
                    setTripDetail({
                        id: advertData.ID,
                        advertTypeId: advertData.Advert_Type_ID || 1,
                        advertTypeTitle: advertType.Advert_Type_Title || "Bilinmiyor",
                        direction: advertData.Direction_Type || "Belirtilmedi",
                        distance: advertData.Advert_KM ? `${advertData.Advert_KM} km` : (location.Km ? `${location.Km} km` : "-"),
                        duration: advertData.Estimated_Duration || "00:00",
                        price: advertData.Price || 0,
                        quickOfferPrice: advertData.Quick_Offer_Price ?? null,
                        fuelStatus: advertData.Fuel_Status || "Bilgi yok",
                        customerNotes: advertData.Customer_Notes || "Müşteri notu bulunmuyor.",
                        isAdminCheck: advertData.Is_AdminCheck,
                        isActive: advertData.Is_Active,
                        
                        start: {
                            city: `${location.Start_City_Code || ''} ${location.Advert_Location_StartAddress?.split(',')[0] || ''}`,
                            date: advertData.Advert_DateTime ? new Date(advertData.Advert_DateTime).toLocaleString('tr-TR') : "-",
                            address: location.Advert_Location_StartAddress || "-",
                            countryFlag: "🇹🇷" 
                        },
                        end: {
                            city: `${location.Finish_City_Code || ''} ${location.Advert_Location_FinishAddress?.split(',')[0] || ''}`,
                            date: advertData.Advert_DateTime2 ? new Date(advertData.Advert_DateTime2).toLocaleString('tr-TR') : "-",
                            address: location.Advert_Location_FinishAddress || "-",
                            countryFlag: "🇹🇷"
                        },
                        deadline: advertData.Advert_DateTime3 ? new Date(advertData.Advert_DateTime3).toLocaleString('tr-TR') : "-",
                        advertStartISO: advertData.Advert_DateTime || null,
                        advertEndISO: advertData.Advert_DateTime2 || null,

                        vehicle: {
                            brand: car.Users_Car_Brand || "-",
                            model: car.Users_Car_Model || "-",
                            engine: car.Engine_Type || "-",
                            bodyType: car.Car_Body_Type || "-",
                            plate: car.Users_Car_Plate || "-",
                            chassis: car.ChassisInformation || "-"
                        },

                        invoice: invoice ? {
                            id: invoice.ID,
                            number: invoice.Invoince_Number,
                            status: invoice.Invoince_Status,
                            totalAmount: invoice.TotalAmount
                        } : null,

                        offers: offers,
                        deliveryStatus: advertData.Advert_DeliveryStatus || [],
                        documents: advertData.Advert_Document || [],
                        
                        // GÜNCELLENDİ: Artık doğru tabloya ve doğru ID'ye giderek çekilen masraflar atanıyor
                        expenses: currentOfferExpenses, 
                        
                        taskReports: advertData.Advert_Task_Report || [],
                        ratings: advertData.Advert_Rating || [],
                        
                        services: [
                            "Geri dönmeden önce yolculuğun sonunda beklemek",
                            "Profesyonel sürücü talep edildi"
                        ]
                    });
                } else {
                    setTripDetail(null);
                }
            } catch (error) {
                console.error("Detaylar çekilirken hata:", error);
                setTripDetail(null);
            } finally {
                setIsLoading(false);
            }
        };

        if (id) {
            fetchAdvertDetails();
        }
    }, [id, userId]);

    // Borç kontrolü — teklif verebilen roller için
    useEffect(() => {
        if (!userId || !canBid) return;
        hasUnpaidCancelFee(userId)
            .then(({ hasDebt: hd, totalDebt }) => {
                setHasDebt(hd);
                setDebtAmount(totalDebt);
            })
            .catch(() => {});
    }, [userId, canBid]);
    

    // KADEMELİ İPTAL POLİTİKASI — modal aç
    const handleCancelTask = async () => {
        if (!tripDetail?.advertStartISO) return;

        const startDate = new Date(tripDetail.advertStartISO);
        const now = new Date();
        const startDay = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const diffDays = Math.round((startDay.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));

        if (diffDays < 0) {
            toast.error("Geçmiş tarihli görev iptal edilemez.");
            return;
        }

        let policies = [];
        try {
            policies = await fetchCancelPolicies();
        } catch {
            toast.error("İptal politikası yüklenemedi. Lütfen tekrar deneyin.");
            return;
        }

        const { fee, pricingId } = calcCancelFee(diffDays, policies);
        const feeMsg = fee > 0
            ? `${fee} TL iptal cezası kesilecektir.`
            : `Ücretsiz iptal (${diffDays} gün kala).`;

        setCancelModal({ open: true, fee, feeMsg, pricingId, diffDays });
    };

    // İptal onaylandıktan sonra çalışır
    const confirmCancelTask = async () => {
        const { fee, pricingId } = cancelModal;
        setCancelling(true);
        try {
            await fetch(`https://hiflowapi.stechomeyazilim.info/Advert(${tripDetail.id})`, {
                method: "PATCH",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ Is_Active: false })
            });

            if (fee > 0 && pricingId) {
                await fetch(`https://hiflowapi.stechomeyazilim.info/Users_Advert_Pricing`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        Advert_ID: Number(tripDetail.id),
                        Users_ID: Number(userId),
                        Advert_Pricing_ID: pricingId,
                        Price: fee
                    })
                });
            }

            toast.success(`Görev iptal edildi.${fee > 0 ? ` Kesilen ceza: ${fee} TL` : " Ücretsiz iptal."}`);
            setCancelModal({ open: false, fee: 0, feeMsg: "", pricingId: null, diffDays: 0 });
            setTimeout(() => window.location.reload(), 1500);
        } catch {
            toast.error("İptal işlemi sırasında hata oluştu. Lütfen tekrar deneyin.");
        } finally {
            setCancelling(false);
        }
    };

    // OData formatına zamanı çevirme (örnek: "14:30" -> "PT14H30M0S")
    const formatToDuration = (timeStr) => {
        if (!timeStr) return null;
        const [h, m] = timeStr.split(':');
        return `PT${parseInt(h)}H${parseInt(m)}M0S`;
    };

    // ISO string'den YYYY-MM-DD (tarih input değeri)
    const isoToDateVal = (iso) => (iso ? iso.substring(0, 10) : "");
    // ISO string'den HH:MM (time input değeri)
    const isoToTimeVal = (iso) => {
        if (!iso) return "";
        const d = new Date(iso);
        return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
    };

    // HIZLI TEKLİF GÖNDERME FONKSİYONU
    const handleQuickBidSubmit = async () => {
        // Sürücü / Admin → teklif öncesi ödenmemiş ceza kontrolü
        if (hasDebt) {
            toast.error(`${debtAmount} TL ödenmemiş cezanız var. Borcu ödemeden teklif veremezsiniz.`);
            return;
        }
        try {
            setQuickBidLoading(true);

            const price = tripDetail.quickOfferPrice != null && tripDetail.quickOfferPrice > 0
                ? Number(tripDetail.quickOfferPrice)
                : Number(tripDetail.price);
            const finalPrice = price;
            
            // API'ye ilanın kendi başlangıç ve bitiş zamanlarını gönderiyoruz
            const payload = {
                Advert_ID: Number(tripDetail.id),
                Users_ID: Number(userId),
                Price: price,
                Travel_Expenses: 0,
                Delivery_Date: tripDetail.advertStartISO ? isoToDateVal(tripDetail.advertStartISO) : new Date().toISOString().substring(0, 10),
                DateTime_: tripDetail.advertEndISO ? isoToDateVal(tripDetail.advertEndISO) : new Date().toISOString().substring(0, 10),
                Start_Time: tripDetail.advertStartISO ? formatToDuration(isoToTimeVal(tripDetail.advertStartISO)) : "PT00H00M0S",
                End_Time: tripDetail.advertEndISO ? formatToDuration(isoToTimeVal(tripDetail.advertEndISO)) : "PT00H00M0S",
                Own_Offer: finalPrice,
                Created_DateTime: new Date().toISOString(),
                IsUpdated: false,
                Quickly: true,
                Offer_Status: "Onaylandı" 
            };

            const response = await fetch("https://hiflowapi.stechomeyazilim.info/Advert_Offers", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error("Teklif gönderilemedi");
            }

            // Backend'den dönen cevabı güvenli bir şekilde alıyoruz
            let newOfferFromServer = {};
            try {
                newOfferFromServer = await response.json();
            } catch (e) {
                console.warn("API yanıtı boş veya JSON değil, sadece payload kullanılacak.");
            }

            // EKRAN HATALARINI (NaN) ÖNLEYEN KRİTİK KISIM:
            // Gönderdiğimiz eksiksiz payload ile sunucudan gelen ID vb. bilgileri birleştiriyoruz
            const createdOffer = {
                ...payload,
                ...newOfferFromServer,
                Users: authUser
            };

            toast.success(`Teklifiniz ${price.toFixed(2)} TL olarak gönderildi ve görev size atandı!`);
            
            setQuickBidModal(false);
            
            // State'e garanti olan birleştirilmiş veriyi yazıyoruz
            setUserOffer(createdOffer);

            setTripDetail(prev => ({
                ...prev,
                offers: [...(prev.offers || []), createdOffer]
            }));

        } catch (error) {
            console.error("QUICK BID ERROR:", error);
            toast.error("Hızlı teklif gönderilirken bir hata oluştu.");
        } finally {
            setQuickBidLoading(false);
        }
    };

    const handleOpenQuickOfferEdit = () => {
        setQuickOfferEditValue(
            tripDetail?.quickOfferPrice != null
                ? tripDetail.quickOfferPrice.toString()
                : ""
        );
        setQuickOfferEditModal(true);
    };

    const handleSaveQuickOfferPrice = async () => {
        const val = parseFloat(quickOfferEditValue);
        if (isNaN(val) || val < 0) {
            toast.error("Geçerli bir tutar giriniz.");
            return;
        }
        setQuickOfferSaveLoading(true);
        try {
            const res = await fetch(
                `https://hiflowapi.stechomeyazilim.info/Advert(${id})`,
                {
                    method: "PATCH",
                    headers: { "Content-Type": "application/json", Accept: "application/json" },
                    body: JSON.stringify({ Quick_Offer_Price: val }),
                }
            );
            if (!res.ok) throw new Error();
            setTripDetail(prev => ({ ...prev, quickOfferPrice: val }));
            setQuickOfferEditModal(false);
            toast.success(`Hızlı teklif fiyatı ${val.toFixed(2)} TL olarak güncellendi.`);
        } catch {
            toast.error("Kayıt sırasında hata oluştu.");
        } finally {
            setQuickOfferSaveLoading(false);
        }
    };

    return (
        <React.Fragment>
            <ToastContainer position="top-right" autoClose={3500} />
             <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Uygun İşler" breadcrumbItem="Taşıma Detayları" />

                    {/* Borç uyarı banner'ı */}
                    {hasDebt && canBid && (
                        <Alert color="danger" className="d-flex align-items-center justify-content-between mb-3 shadow-sm">
                            <div>
                                <i className="mdi mdi-alert-circle-outline me-2 fs-5"></i>
                                <strong>{debtAmount} TL</strong> tutarında ödenmemiş iptal cezanız var. Borcu ödemeden teklif veremezsiniz.
                            </div>
                            <Button color="danger" size="sm" onClick={() => navigate("/borc-yonetimi")} className="ms-3 fw-bold text-nowrap">
                                <i className="mdi mdi-credit-card-outline me-1"></i> Ceza Öde
                            </Button>
                        </Alert>
                    )}

                    <div className="d-flex align-items-center justify-content-between mb-4">
                       <div className="d-flex align-items-center">
                            {/* navigate(-1) tarayıcı geçmişinde bir önceki sayfaya götürür */}
                            <a href="#!" onClick={(e) => { e.preventDefault(); navigate(-1); }} className="text-dark me-3" style={{ cursor: "pointer" }}>
                                <i className="mdi mdi-arrow-left fs-3"></i>
                            </a>
                            <h3 className="mb-0">Taşıma detayları n°{id}</h3>
                            
                            {tripDetail && (
                                <span className={`badge ms-3 ${tripDetail.isAdminCheck ? 'bg-success' : 'bg-warning'}`}>
                                    {tripDetail.isAdminCheck ? 'Aktif (Onaylı)' : 'Pasif (Onay Bekliyor)'}
                                </span>
                            )}
                        </div>

                        {/* HIZLI TEKLİF FİYATI BİLGİ KARTI (Admin) */}
                        {tripDetail && isAdmin && (
                            <div
                                className="d-flex align-items-center gap-2 px-3 py-2 rounded me-2"
                                style={{ background: "#fff7ed", border: "1.5px solid #fed7aa" }}
                            >
                                <i className="bx bx-zap text-warning fs-5" />
                                <div>
                                    <div style={{ fontSize: 11, color: "#92400e", fontWeight: 600 }}>HIZLI TEKLİF FİYATI</div>
                                    <div style={{ fontSize: 16, fontWeight: 800, color: "#F15A29" }}>
                                        {tripDetail.quickOfferPrice != null && tripDetail.quickOfferPrice > 0
                                            ? `${Number(tripDetail.quickOfferPrice).toFixed(2)} TL`
                                            : "—"}
                                    </div>
                                    <div style={{ fontSize: 11, color: "#64748B" }}>
                                        Toplam: <strong>{Number(tripDetail.price).toFixed(2)} TL</strong>
                                    </div>
                                </div>
                                <Button
                                    size="sm" color="warning" outline
                                    onClick={handleOpenQuickOfferEdit}
                                    style={{ whiteSpace: "nowrap" }}
                                >
                                    <i className="bx bx-edit me-1" />Düzenle
                                </Button>
                            </div>
                        )}

                        {/* CANLI KONUM TAKİBİ (Admin) */}
                        {tripDetail && (isAdmin || isCustomer) && hasLiveLocation && (
                            <Link to={`/job-live-location/${id}`} className="me-2">
                                <Button color="success" size="sm">
                                    <i className="mdi mdi-map-marker-radius me-1"></i> Canlı Konum
                                </Button>
                            </Link>
                        )}

                        {/* AKSİYON BUTONLARI */}
                      {tripDetail && canBid && !isCustomer && (
                            <div className="d-flex gap-2">
{userOffer ? (
    <div className="d-flex flex-column align-items-end border border-info p-2 rounded bg-soft-info">
        <Badge color="info" className="fs-6 mb-2">
            <i className="mdi mdi-check-all me-1"></i> Teklifiniz: {userOffer.Offer_Status || "Bekliyor"}
        </Badge>
        <div className="text-end mb-2">
            <div className="text-muted fw-bold mb-1">
                <i className="mdi mdi-cash-multiple me-1"></i> 
                Tutar: {Number(userOffer.Price).toFixed(2)} TL
            </div>
            <div className="text-muted" style={{ fontSize: "0.85rem" }}>
                <i className="mdi mdi-calendar-clock me-1"></i> 
                Tarih: {new Date(userOffer.Created_DateTime).toLocaleString('tr-TR')}
            </div>
        </div>

       {/* BUTONLAR (İPTAL / DÜZENLE) */}
        <div className="mt-2">
            {userOffer.Offer_Status === "Kabul Edildi" || userOffer.Offer_Status === "Onaylandı" ? (
                // 1. Görev atanmışsa (Kabul edilmişse)
                userOffer.Quickly ? (
                     // Hızlı teklif ise -> İptal edilemez uyarısı
                    <Badge color="danger" className="p-2 border border-dark">
                        <i className="mdi mdi-lock me-1"></i> Hızlı Teklif İptal Edilemez
                    </Badge>
                ) : (
                    // Normal teklif ise -> İptal Et Butonu Çıkar
                    <Button color="danger" size="sm" onClick={handleCancelTask}>
                        <i className="mdi mdi-close-circle me-1"></i> Görevi İptal Et
                    </Button>
                )
            ) : (
                // 2. Henüz atanmamışsa
                userOffer.Quickly ? (
                    // Hızlı teklif ise -> Düzenlenemez uyarısı
                    <Badge color="warning" className="p-2 border border-dark">
                        <i className="mdi mdi-lock me-1"></i> Hızlı Teklif Düzenlenemez
                    </Badge>
                ) : (
                    // Normal teklif ise -> Düzenle butonu çıkar
                    <Button color="primary" size="sm" outline onClick={() => navigate(`/expense-entry/${id}`)}>
                        <i className="mdi mdi-pencil me-1"></i> Teklifi Düzenle
                    </Button>
                )
            )}
        </div>

    </div>
) : towCertBlocked ? (
                                    <div className="border border-warning rounded p-3 bg-soft-warning text-center" style={{ maxWidth: 320 }}>
                                        <i className="mdi mdi-tow-truck text-warning fs-3 d-block mb-1"></i>
                                        <div className="fw-bold text-warning mb-1">Çekici Sertifikası Gerekli</div>
                                        <div className="text-muted" style={{ fontSize: 12 }}>
                                            Bu görev çekici işidir. Teklif verebilmek için "Çekici Sertifikası" yüklemeniz gerekir.
                                        </div>
                                        <Button color="warning" size="sm" outline className="mt-2" onClick={() => navigate("/candidate-list")}>
                                            <i className="mdi mdi-cloud-upload-outline me-1"></i> Sertifika Yükle
                                        </Button>
                                    </div>
                                ) : (
                                    <>
                                        {hasDebt && (
                                            <Button color="danger" size="sm" onClick={() => navigate("/borc-yonetimi")} className="fw-bold">
                                                <i className="mdi mdi-credit-card-outline me-1"></i> Ceza Öde
                                            </Button>
                                        )}
                                        <Button color="warning" outline onClick={toggleQuickBidModal} disabled={hasDebt} title={hasDebt ? "Önce cezanızı ödemeniz gerekiyor" : ""}>
                                            <i className="mdi mdi-flash me-1"></i> Hızlı Teklif Ver
                                        </Button>
                                        <Button color="primary" onClick={() => navigate(`/expense-entry/${id}`)} disabled={hasDebt} title={hasDebt ? "Önce cezanızı ödemeniz gerekiyor" : ""}>
                                            Teklif Oluşturmaya Başla <i className="mdi mdi-chevron-right ms-1"></i>
                                        </Button>
                                    </>
                                )}
                            </div>
                        )}
                    </div>

                    {isLoading ? (
                        <div className="text-center py-5">
                            <Spinner color="primary" /> <p className="mt-2">Detaylar yükleniyor...</p>
                        </div>
                    ) : tripDetail ? (
                        <Row>
                            <DetailsSection detail={tripDetail} />
                            <Overview detail={tripDetail} isAdmin={isAdmin} isDriver={isDriver} isCustomer={isCustomer} />
                        </Row>
                    ) : (
                        <div className="alert alert-danger">Kayıt bulunamadı veya bir hata oluştu.</div>
                    )}
                </Container>
            </div>

            {/* HIZLI TEKLİF MODALI */}
            <Modal isOpen={quickBidModal} toggle={toggleQuickBidModal} centered>
                <ModalHeader toggle={toggleQuickBidModal} className="bg-soft-warning">
                    <i className="mdi mdi-flash text-warning me-2"></i>Hızlı Teklif Ver
                </ModalHeader>
        
        <ModalBody>
                    <div className="alert alert-warning px-3 py-2 mb-0">
                        <p className="mb-2">
                            Bu görev için teklifiniz{" "}
                            {tripDetail?.quickOfferPrice != null && tripDetail.quickOfferPrice > 0 ? (
                                <>
                                    hızlı teklif fiyatı olan{" "}
                                    <strong>{Number(tripDetail.quickOfferPrice).toFixed(2)} TL</strong>
                                </>
                            ) : (
                                <>
                                    ilan fiyatı olan{" "}
                                    <strong>{tripDetail?.price ? Number(tripDetail.price).toFixed(2) : "0.00"} TL</strong>
                                </>
                            )}{" "}
                            üzerinden gönderilecektir.
                        </p>
                        <div className="bg-soft-danger text-danger p-2 rounded fw-bold mb-2" style={{fontSize:"13px"}}>
                            <i className="mdi mdi-alert-circle-outline me-1"></i>
                            ÖNEMLİ: Hızlı teklif verdiğinizde teklifiniz sistem tarafından <u>otomatik olarak onaylanır</u> ve görev anında size atanır!
                        </div>
                        {tripDetail?.advertStartISO && tripDetail?.advertEndISO && (
                            <div className="text-dark mt-2" style={{fontSize:"13px"}}>
                                <i className="mdi mdi-calendar-clock me-1"></i>
                                <strong>Görev Zamanı:</strong> {new Date(tripDetail.advertStartISO).toLocaleString('tr-TR')} — {new Date(tripDetail.advertEndISO).toLocaleString('tr-TR')}
                            </div>
                        )}
                    </div>
                </ModalBody>

                <ModalFooter>
                    <Button color="light" onClick={toggleQuickBidModal} disabled={quickBidLoading}>Vazgeç</Button>
                    <Button color="warning" onClick={handleQuickBidSubmit} disabled={quickBidLoading}>
                        {quickBidLoading ? <Spinner size="sm" color="light" /> : "Teklifi Gönder"}
                    </Button>
                </ModalFooter>
            </Modal>

            {/* HIZLI TEKLİF FİYATI DÜZENLEME MODALI (Admin) */}
            <Modal isOpen={quickOfferEditModal} toggle={() => setQuickOfferEditModal(false)} centered size="sm">
                <ModalHeader toggle={() => setQuickOfferEditModal(false)}>
                    <i className="bx bx-zap text-warning me-2"></i>Hızlı Teklif Fiyatını Düzenle
                </ModalHeader>
                <ModalBody>
                    <p style={{ fontSize: 13, color: "#6c757d", marginBottom: 12 }}>
                        İlan toplam tutarı: <strong>{tripDetail?.price ? Number(tripDetail.price).toFixed(2) : "0.00"} TL</strong>
                        <br />
                        Sürücülere gösterilecek hızlı teklif fiyatını manuel olarak belirleyebilirsiniz.
                    </p>
                    <FormGroup>
                        <Label style={{ fontWeight: 600, fontSize: 13 }}>Hızlı Teklif Fiyatı (TL)</Label>
                        <div className="input-group">
                            <span className="input-group-text" style={{ background: "#F15A29", border: "none", color: "#fff" }}>
                                <i className="bx bx-lira" />
                            </span>
                            <Input
                                type="number" min="0" step="0.01"
                                placeholder="0.00"
                                value={quickOfferEditValue}
                                onChange={e => setQuickOfferEditValue(e.target.value)}
                            />
                        </div>
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button color="light" onClick={() => setQuickOfferEditModal(false)} disabled={quickOfferSaveLoading}>
                        İptal
                    </Button>
                    <Button
                        color="warning"
                        onClick={handleSaveQuickOfferPrice}
                        disabled={quickOfferSaveLoading}
                        style={{ display: "flex", alignItems: "center", gap: 6 }}
                    >
                        {quickOfferSaveLoading ? <Spinner size="sm" /> : <i className="bx bx-save" />}
                        Kaydet
                    </Button>
                </ModalFooter>
            </Modal>

            {/* İPTAL ONAY MODALI */}
            <Modal isOpen={cancelModal.open} toggle={() => setCancelModal(m => ({ ...m, open: false }))} centered>
                <ModalHeader toggle={() => setCancelModal(m => ({ ...m, open: false }))} className="bg-danger text-white">
                    <span className="text-white"><i className="mdi mdi-alert-circle-outline me-2"></i> Görevi İptal Et</span>
                </ModalHeader>
                <ModalBody className="p-4 text-center">
                    <i className={`mdi ${cancelModal.fee > 0 ? "mdi-cash-remove text-danger" : "mdi-check-circle text-success"} display-4 mb-3`}></i>
                    <h5 className="fw-bold mb-3">Görevi iptal etmek istediğinize emin misiniz?</h5>
                    <div className="d-flex justify-content-center gap-4 mb-3 text-muted">
                        <span><i className="mdi mdi-calendar me-1"></i> Kalan: <strong>{cancelModal.diffDays} gün</strong></span>
                    </div>
                    <Alert color={cancelModal.fee > 0 ? "danger" : "success"} className="border-0 fw-medium">
                        {cancelModal.fee > 0
                            ? <><i className="mdi mdi-alert-circle-outline me-1"></i> {cancelModal.feeMsg}</>
                            : <><i className="mdi mdi-check-circle-outline me-1"></i> {cancelModal.feeMsg}</>
                        }
                    </Alert>
                </ModalBody>
                <ModalFooter className="justify-content-center border-top-0 pb-4">
                    <Button color="light" className="px-4" onClick={() => setCancelModal(m => ({ ...m, open: false }))} disabled={cancelling}>
                        Vazgeç
                    </Button>
                    <Button color="danger" className="px-4" onClick={confirmCancelTask} disabled={cancelling}>
                        {cancelling ? <Spinner size="sm" /> : <><i className="mdi mdi-close-circle me-1"></i> Evet, İptal Et</>}
                    </Button>
                </ModalFooter>
            </Modal>

        </React.Fragment>
    );
}

export default JobDetails;